module.exports = __webpack_public_path__ + "img/horizontal_3_1_3016.1d59f05b.png";